module.exports = __webpack_public_path__ + "img/dress-front.eb358712.jpg";